import { Loader } from '@itandi/itandi-bb-ui';
import type { FC } from 'react';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { ProfileSetting } from '~/components/specifics/vendors/settings/profiles/ProfileSetting';
import { AccountSetting } from '~/components/specifics/vendors/settings/accounts/AccountSetting';
import { useSessions } from '~/hooks/vendors/useSessions';

export const Page: FC = () => {
  const { data: session } = useSessions().index();

  if (session === null) {
    return <Loader />;
  }

  return (
    <VendorLayoutV2>
      <VendorSettingLayout spMenu>
        {session.admin ? (
          <AccountSetting session={session} />
        ) : (
          <ProfileSetting />
        )}
      </VendorSettingLayout>
    </VendorLayoutV2>
  );
};
